package com.xorrus.trading.lot.relayclient.browser

import com.xorrus.trading.lot.relayclient.model.RemoteText
import kotlinx.browser.window

/** UI-Sprache der Remote-SPAs; es gibt genau diese zwei Fassungen (wie in der Desktop-App). */
enum class Lang { DE, EN }

/**
 * Sprachauflösung der SPAs — schlankes Gegenstück zum Desktop-I18n:
 * Default aus der Browser-Locale (de-* → Deutsch, alles andere → Englisch),
 * expliziter Override origin-scoped in localStorage (kein Cookie, wie die Pairing-Daten).
 *
 * [lang] steht beim Seitenaufbau fest; [switchTo] persistiert und lädt die Seite neu —
 * die SPAs bauen ihre UI vollständig beim Start auf, der Relay-Reconnect greift danach
 * von selbst. Übersetzungs-Parität erzwingt der Compiler über das Strings-Interface
 * der jeweiligen SPA, nicht ein Build-Task.
 */
object I18n {

    private const val STORAGE_KEY = "lot.lang"

    /** Aktive Sprache dieser Seite — Override aus localStorage, sonst Browser-Locale. */
    val lang: Lang = detect()

    private fun detect(): Lang {
        val stored = runCatching { window.localStorage.getItem(STORAGE_KEY) }.getOrNull()
        Lang.entries.firstOrNull { it.name == stored }?.let { return it }
        val browser = runCatching { window.navigator.language }.getOrNull().orEmpty()
        return if (browser.lowercase().startsWith("de")) Lang.DE else Lang.EN
    }

    /** Explizite Wahl persistieren und mit neuer Sprache neu aufbauen; no-op bei gleicher Sprache. */
    fun switchTo(target: Lang) {
        if (target == lang) return
        runCatching { window.localStorage.setItem(STORAGE_KEY, target.name) }
        window.location.reload()
    }
}

/** Zweisprachigen Draht-Text in der aktiven SPA-Sprache auflösen. */
val RemoteText.localized: String
    get() = if (I18n.lang == Lang.DE) de else en

/**
 * Draht-Text mit Abwärtskompatibilität: bevorzugt die zweisprachige Fassung, fällt bei
 * alten Desktops auf das (deutsche) String-Feld zurück.
 */
fun localizedOr(text: RemoteText?, fallback: String?): String? = text?.localized ?: fallback
